import React from 'react'
import { view } from 'react-easy-state'
import { Icon, Result } from 'antd'

const ePub = window.ePub

class DocumentRender extends React.Component {

  loadEpub() {
    const { url, type } = this.props.document

    if (type !== "epub") return

    if (!url) return

    const book = ePub(url)
    const rendition = book.renderTo("viewer", {
      manager: "continuous",
      flow: "scrolled",
      width: "100%",
      height: "1500px",
    })

    // const displayed = rendition.display()
    rendition.display()

  }

  componentDidMount() {
    this.loadEpub()
  }

  render() {

    const { url, type } = this.props.document

    const style = {
      width: '100%',
      height: 'calc(90vh - 10px)',
      paddingTop: 30
    }

    // Removed condition  && RegExp('.pdf$', 'i').test(url)
    if (url && type === 'pdf') {
      return <div style={{...this.props.style}}>
        <div className="document-header"><Icon type="file" /> <h2>{this.props.title}</h2></div>
        <object width="100%" height="70%" style={style} data={url} type="application/pdf">Loading...</object>
      </div>
    }

    if (url && type === 'epub') {
      return (
        <div style={{...this.props.style}}>
          <div className="document-header"><Icon type="file" /> <h2>{this.props.title}</h2></div>
          <div id="viewer" style={{ paddingTop: 30 }}></div>
        </div>
      )
    }

    return <div style={{...this.props.style}}>
      <div className="document-header"><Icon type="file" /> <h2>{this.props.title}</h2></div>
      <Result
        status="warning"
        title="Unsupported file format"
      />
    </div>

  }
}

export default view(DocumentRender)
